<template>
    <v-form v-model="valid"
            v-on:submit.prevent="submitProfile"
    >
        <v-textarea v-for="i in 7"
            class="large_input"
            prepend-icon="fa-comment-alt"
            v-model="form[`about_${i}`]"
            :label="`${ $t('Message') } ${i}`"
            counter
            rows="3"
            maxlength="190"
            :hint="$t(`message_${i}`)"
            :persistent-hint="true"
            :disabled="loading"
        ></v-textarea>
        <v-alert
            v-if="error"
            :value="true"
            type="error"
            class="notranslate"
        >{{ error }}</v-alert>
        <v-btn type="submit"
               :loading="loading"
               :disabled="loading || !valid"
               color="accent"
        >{{ $t('Submit') }}</v-btn>
    </v-form>
</template>

<script>
  import VTextarea from "vuetify/es5/components/VTextarea/VTextarea";
  import VForm from "vuetify/es5/components/VForm/VForm";
  export default {
    name: "ProfileInterview",
    components: {
      VTextarea,
      VForm
    },
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      error: {
        type: Boolean,
        required: true
      },
      info: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      form: {
        about_1: '',
        about_2: '',
        about_3: '',
        about_4: '',
        about_5: '',
        about_6: '',
        about_7: '',
      },
      valid: false
    }),
    methods: {
      submitProfile: function () {
        this.$emit('submit-profile', this.form)
      }
    },
    mounted () {
      if (this.info) {
        Object.keys(this.form).map(key => {
          this.form[key] = this.info[key]
        })
      }
    }
  }
</script>

<style scoped lang="scss">
    .v-form {
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
        .v-input {
            margin: 12px 0;
        }
        .v-input.large_input {
            margin: 30px 0;
        }
        &.disabled {
            pointer-events: none;
            opacity: 0.6;
        }
        button[type=submit] {
            display: block;
            margin: 24px auto 0;
        }
    }
</style>

<i18n>
    {
        "en": {
            "Message": "Message",
            "message_1": "Say hello to your visitors",
            "message_2": "Tell a little about you",
            "message_3": "What inspires you?",
            "message_4": "What do you want to convey with your work?",
            "message_5": "Aside from shooting, editing and drinking coffee, what do you enjoy doing?",
            "message_6": "What gear do you carry with you?",
            "message_7": "Leave your message to the world here on anything you want"
        },
        "pt": {
            "Message": "Mensagem",
            "message_1": "Diga olá para seus visitantes",
            "message_2": "Fale um pouco sobre você",
            "message_3": "O que te inspira?",
            "message_4": "O que você quer transmitir com seu trabalho?",
            "message_5": "Além de disparar, editar e tomar café, o que você gosta de fazer?",
            "message_6": "Que equipamento você leva na mochila?",
            "message_7": "Deixe seu recado para o mundo aqui sobre o que quiser"
        }
    }
</i18n>